export const LAWS_ALL_PUB_APPLY_SEARCH_FILTER = 'LAWS_ALL_PUB_APPLY_SEARCH_FILTER';
export const LAWS_ALL_PUB_REMOVE_SEARCH_ITEM = 'LAWS_ALL_PUB_REMOVE_SEARCH_ITEM';
export const LAWS_ALL_PUB_REMOVE_SEARCH_FILTER = 'LAWS_ALL_PUB_REMOVE_SEARCH_FILTER';
export const LAWS_ALL_PUB_CHANGE_IS_TITLE_ONLY = 'LAWS_ALL_PUB_CHANGE_IS_TITLE_ONLY';

export const LAWS_ALL_PUB_APPLY_CATEGORIES_FILTER = 'LAWS_ALL_PUB_APPLY_CATEGORIES_FILTER';
export const LAWS_ALL_PUB_REMOVE_CATEGORIES_FILTER = 'LAWS_ALL_PUB_REMOVE_CATEGORIES_FILTER';
export const LAWS_ALL_PUB_REMOVE_CATEGORY_FROM_FILTER = 'LAWS_ALL_PUB_REMOVE_CATEGORY_FROM_FILTER';

export const LAWS_ALL_PUB_APPLY_DATES_RANGE_FILTER = 'LAWS_ALL_PUB_APPLY_DATES_RANGE_FILTER';
export const LAWS_ALL_PUB_REMOVE_DATES_RANGE_FILTER = 'LAWS_ALL_PUB_REMOVE_DATES_RANGE_FILTER';

export const LAWS_ALL_PUB_APPLY_THEMES_FILTER = 'LAWS_ALL_PUB_APPLY_THEMES_FILTER';
export const LAWS_ALL_PUB_REMOVE_THEMES_FILTER = 'LAWS_ALL_PUB_REMOVE_THEMES_FILTER';
export const LAWS_ALL_PUB_REMOVE_THEME_FROM_FILTER = 'LAWS_ALL_PUB_REMOVE_THEME_FROM_FILTER';

export const LAWS_ALL_PUB_APPLY_DOCUMENT_TYPE_FILTER = 'LAWS_ALL_PUB_APPLY_DOCUMENT_TYPE_FILTER';
export const LAWS_ALL_PUB_REMOVE_DOCUMENT_TYPE_FILTER = 'LAWS_ALL_PUB_REMOVE_DOCUMENT_TYPE_FILTER';
export const LAWS_ALL_PUB_REMOVE_DOCUMENT_TYPE_FROM_FILTER = 'LAWS_ALL_PUB_REMOVE_DOCUMENT_TYPE_FROM_FILTER';

export const LAWS_ALL_PUB_APPLY_SOURCES_FILTER = 'LAWS_ALL_PUB_APPLY_SOURCES_FILTER';
export const LAWS_ALL_PUB_REMOVE_SOURCES_FILTER = 'LAWS_ALL_PUB_REMOVE_SOURCES_FILTER';
export const LAWS_ALL_PUB_REMOVE_SOURCE_FROM_FILTER = 'LAWS_ALL_PUB_REMOVE_SOURCE_FROM_FILTER';

export const LAWS_ALL_PUB_CHANGE_IMPORTANCE_FILTER = 'LAWS_ALL_PUB_CHANGE_IMPORTANCE_FILTER';

export const LAWS_ALL_PUB_CHANGE_PLAN_FILTER = 'LAWS_ALL_PUB_CHANGE_PLAN_FILTER';

export const LAWS_ALL_PUB_CHANGE_SORT_FILTER = 'LAWS_ALL_PUB_CHANGE_SORT_FILTER';

export const LAWS_ALL_PUB_REMOVE_ALL_FILTERS = 'LAWS_ALL_PUB_REMOVE_ALL_FILTERS';

export const LAWS_ALL_PUB_SET_INITIAL_FILTERS = 'LAWS_ALL_PUB_SET_INITIAL_FILTERS';
export const LAWS_ALL_PUB_SET_FILTERS = 'LAWS_ALL_PUB_SET_FILTERS';

// export const APPLY_COVID_FILTERS = 'APPLY_COVID_FILTERS';



// WEBPACK FOOTER //
// ./src/redux_related/lawsAllPublicationsFilters/actions.js